<template>
  <v-combobox
    filled
    rounded
    solo
    hide-no-data
    hide-details
    clearable
    :readonly="searchClosed == true ? true : false"
    :clear-icon="searchClosed == false ?'$clear':''"
    :search-input.sync="search"
    :placeholder="searchClosed == false ? $t('search') : ''" 
    append-icon="mdi-magnify"
    background-color="#fff"
    data-testid="search-expanding"
    class="expanding-search float-right mb-n3"
    :class="{ 'closed' : searchClosed}"
    :style="mobile()? 'z-index:7':''"
    @focus="searchClosed = false"
    @click:append = openSeach         
          />
</template>
<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import _ from 'lodash'

export default {
    mixins: [repeatedMethodsMixin],
     props: {
  },
  data: function() {
    return { 
      searchClosed:true,
      search: null,
    }
  },
  computed: {
  },
  watch: {
    search: _.debounce(
      function (val) {
        if (val == null || val == '') {
          this.search = null
          this.$emit('resetSearch', val)
        }else{
          let searchkey = val.trim()
          if (searchkey.length < 2) return
          this.$emit('input', searchkey)
        }
      },500),          
  },
  methods: {
    openSeach(){
      if(!this.searchClosed){
        this.search = null
        this.$nextTick(() => {
            this.searchClosed = true
        })
      }else {
        this.searchClosed = false
      }
    }
  },
}
 
</script>